<div class="content">
  <div class="hero" [ngStyle]="{
  'background-image': 'url(' + getCulture3() + ')',
  'background-repeat': 'no-repeat',
  'background-position': 'center 100px',
  'width': '100%',
  'height': '400px',
  'background-attachment': 'fixed'
}">
    <!--<img class="hero-banner" src="assets/images/hero.png" alt="">-->
  </div>
  <div class="description-center">
    <div class="description-center-content" [innerHTML]="'theindicatorscentral'|translate">

    </div>
  </div>

  <div class="panel-table-custom">
    <div class="panel-table-custom-header">
      <img class="panel-table-custom-header-banner" src="{{getCulture()}}" alt="">
    </div>
    <div class="panel-table-custom-body d-flex">
      <div class="panel-table-custom-body-content d-flex">
        <div class="panel-table-custom-body-content-resume-card">
          <div class="panel-table-custom-body-content-resume-card-ball">
            <div class="panel-table-custom-body-content-resume-card-ball-content change-green">
              <span><strong>E</strong></span>
            </div>
          </div>
          <div class="panel-table-custom-body-content-resume-card-content">
            <span
              class="panel-table-custom-body-content-resume-card-content-text"
              [innerHTML]="'inourvision'|translate"></span>
          </div>
        </div>
        <div class="panel-table-custom-body-content-resume-btn">
          <div class="panel-table-custom-body-content-resume-btn-header">
            <span><strong>{{ 'knowmoreabout'|translate }}</strong></span>
          </div>
          <div class="panel-table-custom-body-content-resume-btn-body">
            <a href="https://eurofarma.com.br/responsabilidade-corporativa/meio-ambiente" target="_blank"
               class="btn-ambiental">
              <span><strong>{{ 'clickhere'|translate }}</strong></span>
              <svg-icon class="svg" src="assets/svg/arrowright.svg"></svg-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="style-table page-table">
      <div class="table-responsive">
        <table>

          <tbody>

          <tr>
            <td rowspan="2" class="top"><strong>{{ 'theme'|translate }}</strong></td>
            <td rowspan="2" class="top"><strong>{{ 'indicator'|translate }}</strong></td>


            <td colspan="3" class="top center">
              <div class="d-flex">
                <svg-icon src="assets/svg/row-table-left-min.svg"></svg-icon>
                <strong class="flex-grow-1">2025</strong>
                <svg-icon src="assets/svg/row-table-right-min.svg"></svg-icon>
              </div>
            </td>

            <td colspan="2" class="top center">
              <div class="d-flex" style="min-width: 200px">
                <svg-icon src="assets/svg/row-table-left-min.svg"></svg-icon>
                <strong class="flex-grow-1">2026</strong>
                <svg-icon src="assets/svg/row-table-right-min.svg"></svg-icon>
              </div>
            </td>

          </tr>
          <tr class="head-table">
            <!--<td width="125" class="top center change-table-blue"><strong>1Tri</strong></td>
            <td width="125" class="top center change-table-blue"><strong>2Tri</strong></td>
            <td width="125" class="top center change-table-blue"><strong>3Tri</strong></td>
            <td width="125" class="top center change-table-blue"><strong>4Tri</strong></td>-->
            <!--<td width="125" class="top center change-table-blue"><strong>Consolidado</strong></td>-->

            <td width="125" class="top center change-table-blue"><strong>1Tri</strong></td>
            <td width="125" class="top center change-table-blue"><strong>2Tri</strong></td>
            <!--<td width="125" class="top center change-table-blue"><strong>3Tri</strong></td>
            <td width="125" class="top center change-table-blue"><strong>4Tri</strong></td>-->
            <td class="top center change-table-blue"><strong>Consolidado</strong></td>

            <td width="125" class="top center change-table-blue"><strong>1Tri</strong></td>
            <td width="125" class="top center change-table-blue"><strong>2Tri</strong></td>
          </tr>

          <tr>
            <td>{{ 'moregreen'|translate }}</td>
            <td>{{ 'porcentageparticipation'|translate }}</td>

            <!--<td align="center">9%</td>
            <td align="center">10%</td>
            <td align="center">10%</td>
            <td align="center">11%</td>
            <td align="center">10%</td>-->

            <td align="center">9,20%</td>
            <td align="center">10%</td>
            <!--<td align="center">10%</td>
            <td align="center">22%</td>-->
            <td align="center">22%</td>

            <td align="center">8%</td>
            <td align="center">10%</td>
          </tr>
          <tr>
            <td>{{ 'moregreen'|translate }}</td>
            <td>{{ 'soldunits'|translate }}</td>

            <!--<td align="center">6.286.219</td>
            <td align="center">8.139.770</td>
            <td align="center">7.686.695</td>
            <td align="center">8.276.149</td>
            <td align="center">30.473.179</td>-->

            <td align="center">4.705.952</td>
            <td align="center">9.261.840</td>
            <!--<td align="center">8.910.175</td>
            <td align="center">7.854.111</td>-->
            <td align="center">30.732.078</td>

            <td align="center">6.969.730</td>
            <td align="center">6.503.949</td>
          </tr>
          <tr>
            <td>{{ 'renewwater'|translate }}</td>
            <td>{{ 'percentagewaterreuse'|translate }}</td>

            <!--<td align="center">14%</td>
            <td align="center">13%</td>
            <td align="center">14%</td>
            <td align="center">18%</td>
            <td align="center">12%</td>-->

            <td align="center">24%</td>
            <td align="center">20%</td>
            <!--<td align="center">17%</td>
            <td align="center">20%</td>-->
            <td align="center">20%</td>

            <td align="center">17%</td>
            <td align="center">18%</td>
          </tr>
          <tr>
            <td>{{ 'renewwater'|translate }}</td>
            <td [innerHTML]="'percentagereusetotal'|translate"></td>

            <!--<td align="center">11%</td>
            <td align="center">10%</td>
            <td align="center">10%</td>
            <td align="center">-</td>
            <td align="center">-</td>-->

            <td align="center">9%</td>
            <td align="center">15%</td>
            <!--<td align="center">16%</td>
            <td align="center">15%</td>-->
            <td align="center">15%</td>

            <td align="center">13%</td>
            <td align="center">13%</td>
          </tr>
          <tr>
            <td>{{ 'water'|translate }}</td>
            <td>{{ 'consumptionfor1000'|translate }}</td>

            <!--<td align="center">0,91</td>
            <td align="center">0,98</td>
            <td align="center">0,82</td>
            <td align="center">0,86</td>
            <td align="center">0,89</td>-->

            <td align="center">0,90</td>
            <td align="center">0,85</td>
            <!--<td align="center">0,78</td>
            <td align="center">0,77</td>-->
            <td align="center">0,77</td>

            <td align="center">0,94</td>
            <td align="center">0,91</td>
          </tr>

          <tr>
            <td>{{ 'water'|translate }}</td>
            <td> {{ 'consulptionWaterUnit'|translate }}</td>

            <!--<td align="center">1,09</td>
            <td align="center">1,01</td>
            <td align="center">0,93</td>
            <td align="center">-</td>
            <td align="center">-</td>-->

            <td align="center">1,0</td>
            <td align="center">0,98</td>
            <!--<td align="center">0,90</td>
            <td align="center">0,89</td>-->
            <td align="center">0,89</td>

            <td align="center">1,06</td>
            <td align="center">0,99</td>
          </tr>
          <tr>
            <td>{{ 'energy'|translate }}</td>
            <td> {{ 'consulptionEnergyUnit'|translate }}</td>

            <!--<td align="center">0,86</td>
            <td align="center">0,72</td>
            <td align="center">0,70</td>
            <td align="center">-</td>
            <td align="center">-</td>-->

            <td align="center">0,90</td>
            <td align="center">0,83</td>
            <!--<td align="center">0,77</td>
            <td align="center">0,76</td>-->
            <td align="center">0,76</td>

            <td align="center">0,95</td>
            <td align="center">0,80</td>
          </tr>
          <tr>
            <td>{{ 'energy'|translate }}</td>
            <td>{{ 'consumptionfor1000b'|translate }}</td>

            <!--<td align="center">0,82</td>
            <td align="center">0,73</td>
            <td align="center">0,71</td>
            <td align="center">0,84</td>
            <td align="center">0,77</td>-->

            <td align="center">0,80</td>
            <td align="center">0,83</td>
            <!--<td align="center">0,77</td>
            <td align="center">0,77</td>-->
            <td align="center">0,77</td>

            <td align="center">0,93</td>
            <td align="center">0,94</td>
          </tr>
          <tr>
            <td>{{ 'residue'|translate }}</td>
            <td> {{ 'consulptionResidueUnit'|translate }}</td>

            <!--<td align="center">3,17</td>
            <td align="center">2,58</td>
            <td align="center">2,41</td>
            <td align="center">-</td>
            <td align="center">-</td>-->

            <td align="center">4,10</td>
            <td align="center">3,87</td>
            <!--<td align="center">3,81</td>
            <td align="center">3,89</td>-->
            <td align="center">3,89</td>

            <td align="center">4,31</td>
            <td align="center">3,32</td>
          </tr>


          <tr>
            <td>{{ 'residue'|translate }}</td>
            <td> {{ 'residuegeneration'|translate }}</td>

            <!--<td align="center">2,55</td>
            <td align="center">3,58</td>
            <td align="center">2,41</td>
            <td align="center">2,79</td>
            <td align="center">2,53</td>-->

            <td align="center">2,50</td>
            <td align="center">4,13</td>
            <!--<td align="center">4,33</td>
            <td align="center">3,58</td>-->
            <td align="center">3,58</td>

            <td align="center">4,33</td>
            <td align="center">3,48</td>
          </tr>

          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="panel-table-custom">
    <div class="panel-table-custom-header">
      <img class="panel-table-custom-header-banner" src="assets/images/banner2.png" alt="">
    </div>
    <div class="panel-table-custom-body d-flex">
      <div class="panel-table-custom-body-content d-flex">
        <div class="panel-table-custom-body-content-resume-card">
          <div class="panel-table-custom-body-content-resume-card-ball">
            <div class="panel-table-custom-body-content-resume-card-ball-content change-orange">
              <span><strong>S</strong></span>
            </div>
          </div>
          <div class="panel-table-custom-body-content-resume-card-content">
          <span
            class="panel-table-custom-body-content-resume-card-content-text"
            [innerHTML]="'wehavethecommitment'|translate"></span>
          </div>
        </div>
        <div class="panel-table-custom-body-content-resume-btn">
          <div class="panel-table-custom-body-content-resume-btn-header">
            <span><strong>{{ 'knowmoreaboutourstrategy'|translate }} </strong></span>
          </div>
          <div class="panel-table-custom-body-content-resume-btn-body">
            <a href="https://eurofarma.com.br/responsabilidade-corporativa" target="_blank" class="btn-ambiental">
              <span><strong>{{ 'clickhere'|translate }}</strong></span>
              <svg-icon class="svg" src="assets/svg/arrowright.svg"></svg-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="style-table page-table">
      <div class="table-responsive">
        <table>

          <tbody>

          <tr>
            <td rowspan="2" class="top"><strong>{{ 'theme'|translate }}</strong></td>
            <td rowspan="2" class="top"><strong>{{ 'indicator'|translate }}</strong></td>

            <td colspan="3" class="top center">
              <div class="d-flex">
                <svg-icon src="assets/svg/row-table-left-min.svg"></svg-icon>
                <strong class="flex-grow-1">2025</strong>
                <svg-icon src="assets/svg/row-table-right-min.svg"></svg-icon>
              </div>
            </td>

            <td colspan="2" class="top center">
              <div class="d-flex" style="min-width: 200px">
                <svg-icon src="assets/svg/row-table-left-min.svg"></svg-icon>
                <strong class="flex-grow-1">2026</strong>
                <svg-icon src="assets/svg/row-table-right-min.svg"></svg-icon>
              </div>
            </td>
          </tr>
          <tr class="head-table">
            <!--<td width="125" class="top center change-table-blue"><strong>1Tri</strong></td>
            <td width="125" class="top center change-table-blue"><strong>2Tri</strong></td>
            <td width="125" class="top center change-table-blue"><strong>3Tri</strong></td>
            <td width="125" class="top center change-table-blue"><strong>4Tri</strong></td>
            <td class="top center change-table-blue"><strong>Consolidado</strong></td>-->

            <td width="125" class="top center change-table-blue"><strong>1Tri</strong></td>
            <td width="125" class="top center change-table-blue"><strong>2Tri</strong></td>
            <!--<td width="125" class="top center change-table-blue"><strong>3Tri</strong></td>
            <td width="125" class="top center change-table-blue"><strong>4Tri</strong></td>-->
            <td width="125" class="top center change-table-blue"><strong>Consolidado</strong></td>

            <td width="125" class="top center change-table-blue"><strong>1Tri</strong></td>
            <td width="125" class="top center change-table-blue"><strong>2Tri</strong></td>
          </tr>

          <tr>
            <td>{{ 'inclusionanddiversity'|translate }}</td>
            <td>{{ 'percentageofwoman'|translate }}</td>

            <!--<td align="center">30%</td>
            <td align="center">31%</td>
            <td align="center">32%</td>
            <td align="center">34%</td>
            <td align="center">34%</td>-->

            <td align="center">33%</td>
            <td align="center">35%</td>
            <!--<td align="center">35%</td>
            <td align="center">36%</td>-->
            <td align="center">36%</td>

            <td align="center">34%</td>
            <td align="center">36%</td>

          </tr>
          <tr>
            <td>{{ 'inclusionanddiversity'|translate }}</td>
            <td>{{ 'percentageofwomanhigh'|translate }}</td>

            <!--<td align="center">50%</td>
            <td align="center">51%</td>
            <td align="center">51%</td>
            <td align="center">51%</td>
            <td align="center">51%</td>-->

            <td align="center">-</td>
            <td align="center">48%</td>
            <!--<td align="center">51%</td>
            <td align="center">52%</td>-->
            <td align="center">52%</td>

            <td align="center">49%</td>
            <td align="center">48,94%</td>

          </tr>
          <tr>
            <td>{{ 'inclusionanddiversity'|translate }}</td>
            <td>{{ 'percentageofwomanselling'|translate }}</td>

            <!--<td align="center">61%</td>
            <td align="center">66%</td>
            <td align="center">64%</td>
            <td align="center">64%</td>
            <td align="center">64%</td>-->

            <td align="center">62%</td>
            <td align="center">63%</td>
            <!--<td align="center">65%</td>
            <td align="center">63%</td>-->
            <td align="center">63%</td>

            <td align="center">51%</td>
            <td align="center">57%</td>
          </tr>
          <tr>
            <td>{{ 'inclusionanddiversity'|translate }}</td>
            <td>{{ 'percentageofwomanoperation'|translate }}</td>

            <!--<td align="center">54%</td>
            <td align="center">47%</td>
            <td align="center">45%</td>
            <td align="center">47%</td>
            <td align="center">47%</td>-->

            <td align="center">69%</td>
            <td align="center">52%</td>
            <!--<td align="center">49%</td>
            <td align="center">52%</td>-->
            <td align="center">52%</td>

            <td align="center">52%</td>
            <td align="center">52%</td>
          </tr>
          <tr>
            <td>{{ 'socialprivateinvestmemt'|translate }}</td>
            <td>{{ 'totalinvested'|translate }}</td>

            <!--<td align="center">-</td>
            <td align="center">40.150.520,46</td>
            <td align="center">19.624.332,25</td>
            <td align="center">-</td>
            <td align="center">-</td>-->

            <td align="center">11.479.157</td>
            <td align="center">17.410.852,52</td>
            <!--<td align="center">12.757.477,66</td>
            <td align="center">13.969.218,18</td>-->
            <td align="center">55.616.705,36</td>

            <td align="center">10.144.827,33</td>
            <td align="center">11.862.969,64</td>
          </tr>

          <tr>
            <td>{{ 'socialprivateinvestmemt'|translate }}</td>
            <td>{{ 'percentageinvestmentsocial'|translate }}</td>

            <!--<td align="center">3,4%</td>
            <td align="center">3,9%</td>
            <td align="center">6,8%</td>
            <td align="center">-</td>
            <td align="center">-</td>-->

            <td align="center">2,3%</td>
            <td align="center">5,1%</td>
            <!--<td align="center">4,5%</td>
            <td align="center">4,1%</td>-->
            <td align="center">4,01%</td>

            <td align="center">3,1%</td>
            <td align="center">4,6%</td>

          </tr>

          <tr>
            <td>{{ 'socialprivateinvestmemt'|translate }}</td>
            <td>{{ 'quantityofmedicationgiven'|translate }}</td>

            <!--<td align="center">{{ '342.883'|translate }}</td>
            <td align="center">514.357</td>
            <td align="center">129.209</td>
            <td align="center">151.764</td>
            <td align="center">1.138.213</td>-->

            <td align="center">68.583</td>
            <td align="center">81.904</td>
            <!--<td align="center">179.900</td>
            <td align="center">215.500</td>-->
            <td align="center">545.887</td>

            <td align="center">278.683</td>
            <td align="center">580.076</td>
          </tr>

          <tr>
            <td>{{ 'socialprivateinvestmemt'|translate }}</td>
            <td>{{ 'quantityofbasic'|translate }}</td>

            <!--<td align="center">{{ '47.535'|translate }}</td>
            <td align="center">50.335</td>
            <td align="center">49.335</td>
            <td align="center">49.668</td>
            <td align="center">196.873</td>-->

            <td align="center">49.335</td>
            <td align="center">45.015</td>
            <!--<td align="center">45.015</td>
            <td align="center">45.015</td>-->
            <td align="center">184.380</td>

            <td align="center">45.015</td>
            <td align="center">45.014</td>
          </tr>

          <tr>
            <td>{{ 'pbsf'|translate }}</td>
            <td>{{ 'numberofbabies'|translate }}</td>

            <!--<td align="center">137</td>
            <td align="center">133</td>
            <td align="center">138</td>
            <td align="center">155</td>
            <td align="center">563</td>-->

            <td align="center">146</td>
            <td align="center">628</td>
            <!--<td align="center">142</td>
            <td align="center">312</td>-->
            <td align="center">1.228</td>

            <td align="center">266</td>
            <td align="center">385</td>
          </tr>

          <tr>
            <td>{{ 'pbsf'|translate }}</td>
            <td>{{ 'numberofhoursmonitored'|translate }}</td>

            <!--<td align="center">9.570</td>
            <td align="center">8.957</td>
            <td align="center">8.851</td>
            <td align="center">9.198</td>
            <td align="center">36.576</td>-->

            <td align="center">9.057</td>
            <td align="center">9.783</td>
            <!--<td align="center">9.629</td>
            <td align="center">8.395</td>-->
            <td align="center">36.864</td>

            <td align="center">8.736</td>
            <td align="center">16.363</td>
          </tr>

          <tr>
            <td>{{ 'humanmilkbank'|translate }}</td>
            <td>{{ 'numberofbabiesattended'|translate }}</td>

            <!--<td align="center">430</td>
            <td align="center">455</td>
            <td align="center">406</td>
            <td align="center">664</td>
            <td align="center">1.955</td>-->

            <td align="center">146</td>
            <td align="center">141</td>
            <!--<td align="center">159</td>
            <td align="center">145</td>-->
            <td align="center">591</td>

            <td align="center">143</td>
            <td align="center">258</td>
          </tr>

          <tr>
            <td>{{ 'humanmilkbank'|translate }}</td>
            <td>{{ 'donorsquantity'|translate }}</td>

            <!--<td align="center">941</td>
            <td align="center">965</td>
            <td align="center">1.080</td>
            <td align="center">825</td>
            <td align="center">3.811</td>-->

            <td align="center">901</td>
            <td align="center">791</td>
            <!--<td align="center">793</td>
            <td align="center">745</td>-->
            <td align="center">3.230</td>

            <td align="center">690</td>
            <td align="center">739</td>
          </tr>

          <tr>
            <td>{{ 'humanmilkbank'|translate }}</td>
            <td>{{ 'totalInvestimentLactare'|translate }}</td>

            <!--<td align="center">1.089.910</td>
            <td align="center">1.020.289</td>
            <td align="center">1.249.269</td>
            <td align="center">-</td>
            <td align="center">-</td>-->

            <td align="center">1.132.539</td>
            <td align="center">1.223.884</td>
            <!--<td align="center">1.379.804</td>
            <td align="center">877.819</td>-->
            <td align="center">4.614.046</td>

            <td align="center">1.130.419</td>
            <td align="center">1.342.525</td>
          </tr>

          <tr>
            <td>{{ 'eurofarmainstitute'|translate }}</td>
            <td>{{ 'totalinvestment'|translate }}</td>

            <!--<td align="center">{{ '5.205.000'|translate }}</td>
            <td align="center">7.005.000</td>
            <td align="center">6.530.000</td>
            <td align="center">-</td>
            <td align="center">-</td>-->

            <td align="center"> 12.587.052,70</td>
            <td align="center">6.975.000</td>
            <!--<td align="center">7.395.000</td>
            <td align="center">9.400.145</td>-->
            <td align="center">36.357.198</td>

            <td align="center">5.165.000</td>
            <td align="center">6.838.000</td>
          </tr>

          <tr>
            <td>{{ 'eurofarmainstitute'|translate }}</td>
            <td>{{ 'totalyoungattended'|translate }}</td>

            <!--<td align="center">{{ '8.168'|translate }}</td>
            <td align="center">6.200</td>
            <td align="center">5.598</td>
            <td align="center">1.422</td>
            <td align="center">21.388</td>-->

            <td align="center">7.112</td>
            <td align="center">15.044</td>
            <!--<td align="center">73.580</td>
            <td align="center">72.000</td>-->
            <td align="center">167.736</td>

            <td align="center">8.810</td>
            <td align="center">6.939</td>
          </tr>

          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="panel-table-custom">
    <div class="panel-table-custom-header">
      <img class="panel-table-custom-header-banner" src="{{getCulture2()}}" alt="">
    </div>
    <div class="panel-table-custom-body d-flex">
      <div class="panel-table-custom-body-content d-flex">
        <div class="panel-table-custom-body-content-resume-card">
          <div class="panel-table-custom-body-content-resume-card-ball">
            <div class="panel-table-custom-body-content-resume-card-ball-content">
              <span><strong>G</strong></span>
            </div>
          </div>
          <div class="panel-table-custom-body-content-resume-card-content">
          <span
            class="panel-table-custom-body-content-resume-card-content-text"
            [innerHTML]="'wefollowrigorous'|translate"></span>

          </div>
        </div>
        <div class="panel-table-custom-body-content-resume-btn">
          <div class="panel-table-custom-body-content-resume-btn-header">
            <span><strong>{{ 'knowmoreaboutourgoverning'|translate }}</strong></span>
          </div>
          <div class="panel-table-custom-body-content-resume-btn-body">
            <a href="https://eurofarma.com.br/governanca-corporativa" target="_blank" class="btn-ambiental">
              <span><strong>{{ 'clickhere'|translate }}</strong></span>
              <svg-icon class="svg" src="assets/svg/arrowright.svg"></svg-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="style-table page-table">
      <div class="table-responsive">
        <table border="0">

          <tbody>

          <tr>
            <td rowspan="2" class="top"><strong>{{ 'theme'|translate }}</strong></td>
            <td rowspan="2" class="top"><strong>{{ 'indicator'|translate }}</strong></td>

            <td colspan="3" class="top center">
              <div class="d-flex">
                <svg-icon src="assets/svg/row-table-left-min.svg"></svg-icon>
                <strong class="flex-grow-1">2025</strong>
                <svg-icon src="assets/svg/row-table-right-min.svg"></svg-icon>
              </div>
            </td>

            <td colspan="2" class="top center">
              <div class="d-flex" style="min-width: 200px">
                <svg-icon src="assets/svg/row-table-left-min.svg"></svg-icon>
                <strong class="flex-grow-1">2026</strong>
                <svg-icon src="assets/svg/row-table-right-min.svg"></svg-icon>
              </div>
            </td>
          </tr>
          <tr class="head-table">
            <!--<td width="125" class="top center change-table-blue"><strong>1Tri</strong></td>
            <td width="125" class="top center change-table-blue"><strong>2Tri</strong></td>
            <td width="125" class="top center change-table-blue"><strong>3Tri</strong></td>
            <td width="125" class="top center change-table-blue"><strong>4Tri</strong></td>
            <td class="top center change-table-blue"><strong>Consolidado</strong></td>-->

            <td width="125" class="top center change-table-blue"><strong>1Tri</strong></td>
            <td width="125" class="top center change-table-blue"><strong>2Tri</strong></td>
            <!--<td width="125" class="top center change-table-blue"><strong>3Tri</strong></td>
            <td width="125" class="top center change-table-blue"><strong>4Tri</strong></td>-->
            <td width="125" class="top center change-table-blue"><strong>Consolidado</strong></td>

            <td width="125" class="top center change-table-blue"><strong>1Tri</strong></td>
            <td width="125" class="top center change-table-blue"><strong>2Tri</strong></td>
          </tr>

          <tr>
            <td>{{ 'chainofsupriments'|translate }}</td>
            <td>{{ 'localdistributors'|translate }}</td>

            <!--<td align="center">95%</td>
            <td align="center">64%</td>
            <td align="center">63%</td>
            <td align="center">61%</td>
            <td align="center">61%</td>-->

            <td align="center">71%</td>
            <td align="center">69%</td>
            <!--<td align="center">69%</td>
            <td align="center">67%</td>-->
            <td align="center">67%</td>

            <td align="center">67%</td>
            <td align="center">69%</td>
          </tr>

          <tr>
            <td>{{ 'chainofsupriments'|translate }}</td>
            <td>{{ 'localdistributorsin'|translate }}</td>

            <!--<td align="center">92%</td>
            <td align="center">93%</td>
            <td align="center">91%</td>
            <td align="center">89%</td>
            <td align="center">-</td>-->

            <td align="center">92%</td>
            <td align="center">71%</td>
            <!--<td align="center">83%</td>
            <td align="center">85%</td>-->
            <td align="center">85%</td>

            <td align="center">85%</td>
            <td align="center">79%</td>
          </tr>

          <tr>
            <td>{{ 'suppliersmonitorement'|translate }}</td>
            <td>{{ 'esgaudit'|translate }}</td>

            <!--<td align="center">50</td>
            <td align="center">49</td>
            <td align="center">32</td>
            <td align="center">71</td>
            <td align="center">202</td-->

            <td align="center">14</td>
            <td align="center">45</td>
            <!--<td align="center">63</td>
            <td align="center">74</td>-->
            <td align="center">196</td>

            <td align="center">46</td>
            <td align="center">37</td>

          </tr>

          <!--          <tr>-->
          <!--            <td>Reputação</td>-->
          <!--            <td>Posistividade na Mídia</td>-->
          <!--            <td align="center">100%</td>-->
          <!--            <td align="center">87%</td>-->
          <!--            <td align="center">100%</td>-->
          <!--            <td align="center">99%</td>-->
          <!--            <td align="center">97%</td>-->
          <!--            <td align="center">100%</td>-->
          <!--            <td align="center">99,8%</td>-->
          <!--            <td align="center">15%</td>-->
          <!--          </tr>-->

          <tr>
            <td>{{ 'consummersatisfaction'|translate }}</td>
            <td>{{ 'consummersatisfactionlevelHealthProfessional'|translate }}</td>

            <!--<td align="center">84%</td>
            <td align="center">81%</td>
            <td align="center">81%</td>
            <td align="center">-</td>
            <td align="center">-</td>-->

            <td align="center">80%</td>
            <td align="center">76%</td>
            <!--<td align="center">84%</td>
            <td align="center">87%</td>-->
            <td align="center">87%</td>

            <td align="center">88%</td>
            <td align="center">77%</td>
          </tr>

          <tr>
            <td>{{ 'consummersatisfaction'|translate }}</td>
            <td>{{ 'consummersatisfactionlevel'|translate }}</td>

            <!--<td align="center">84%</td>
            <td align="center">-</td>
            <td align="center">0</td>
            <td align="center">-</td>
            <td align="center">-</td>-->

            <td align="center">80%</td>
            <td align="center">92,70%</td>
            <!--<td align="center">96,60%</td>
            <td align="center">94,40%</td>-->
            <td align="center">94,40%</td>

            <td align="center">86%</td>
            <td align="center">80%</td>
          </tr>

          <!--          <tr>-->
          <!--            <td>Satisfação Clientes</td>-->
          <!--            <td>% Nível de Serviço para principais clientes</td>-->
          <!--            <td align="center">-</td>-->
          <!--            <td align="center">90%</td>-->
          <!--            <td align="center">-</td>-->
          <!--            <td align="center">-</td>-->
          <!--            <td align="center">66%</td>-->
          <!--            <td align="center">78%</td>-->
          <!--            <td align="center">86%</td>-->
          <!--            <td align="center">-4%</td>-->
          <!--          </tr>-->

          <tr>
            <td>{{ 'workerssatisfaction'|translate }}</td>
            <td>{{ 'GPTW'|translate }}</td>

            <!--<td align="center">Apuração apenas no final do ano</td>
            <td align="center">Apuração apenas no final do ano</td>
            <td align="center">92%</td>
            <td align="center">92%</td>
            <td align="center">92%</td>-->

            <td align="center">-</td>
            <td align="center">89%</td>
            <!--<td align="center">89%</td>
            <td align="center">89%</td>-->
            <td align="center">89%</td>

            <td align="center">91%</td>
            <td align="center">91%</td>
          </tr>

          <!--<tr>
            <td>Compliance</td>
            <td>{{'preceedingocurrences'|translate}}</td>
            <td align="center">14.12%</td>
            <td align="center">15.86%</td>
            <td align="center">-</td>
            <td align="center">-</td>
            <td align="center">-</td>
            <td align="center">-</td>
          </tr>-->


          <tr>
            <td>{{ 'compliance'|translate }}</td>
            <td>{{ 'actionTrainingEmployee'|translate }}</td>

            <!--<td align="center">8</td>
            <td align="center">27</td>
            <td align="center">16</td>
            <td align="center">-</td>
            <td align="center">-</td>-->

            <td align="center">11</td>
            <td align="center">19</td>
            <!--<td align="center">21</td>
            <td align="center">24</td>-->
            <td align="center">75</td>

            <td align="center">21</td>
            <td align="center">35</td>
          </tr>
          <tr>
            <td>{{ 'compliance'|translate }}</td>
            <td>{{ 'actionTrainingThird'|translate }}</td>

            <!--<td align="center">3</td>
            <td align="center">21</td>
            <td align="center">3</td>
            <td align="center">-</td>
            <td align="center">-</td>-->

            <td align="center">3</td>
            <td align="center">123</td>
            <!--<td align="center">51</td>
            <td align="center">65</td>-->
            <td align="center">242</td>

            <td align="center">110</td>
            <td align="center">64</td>
          </tr>
          <tr>
            <td>{{ 'compliance'|translate }}</td>
            <td>{{ 'actionCommunication'|translate }}</td>

            <!--<td align="center">4</td>
            <td align="center">8</td>
            <td align="center">7</td>
            <td align="center">7</td>
            <td align="center">22</td-->

            <td align="center">6</td>
            <td align="center">9</td>
            <!--<td align="center">8</td>
            <td align="center">9</td>-->
            <td align="center">32</td>

            <td align="center">16</td>
            <td align="center">27</td>
          </tr>


          <tr>
            <td>{{ 'compliance'|translate }}</td>
            <td>{{ 'numberoflayoffs'|translate }}</td>

            <!--<td align="center">7</td>
            <td align="center">35</td>
            <td align="center">39</td>
            <td align="center">17</td>
            <td align="center">-</td>-->

            <td align="center">15</td>
            <td align="center">15</td>
            <!--<td align="center">25</td>
            <td align="center">19</td>-->
            <td align="center">74</td>

            <td align="center">8</td>
            <td align="center">13</td>
          </tr>

          <tr>
            <td>{{ 'competitivness'|translate }}</td>
            <td>{{ 'latamposition'|translate }}</td>

            <!--<td align="center">2a posição</td>
            <td align="center">2a posição</td>
            <td align="center">2a posição</td>
            <td align="center">1a posição</td>
            <td align="center">1a posição</td>-->

            <td align="center">2a posição</td>
            <td align="center">2a posição</td>
            <!--<td align="center">1a posição</td>
            <td align="center">1a posição</td>-->
            <td align="center">1a posição</td>

            <td align="center">1a posição</td>
            <td align="center">2a posição</td>

          </tr>

          <tr>
            <td>{{ 'competitivness'|translate }}</td>
            <td>Market Share Varejo BR</td>

            <!--<td align="center">6,39%</td>
            <td align="center">6,78%</td>
            <td align="center">6,75%</td>
            <td align="center">6,81%</td>
            <td align="center">6,81%</td>-->

            <td align="center">6,80%</td>
            <td align="center">6,79%</td>
            <!--<td align="center">6,85%</td>
            <td align="center">6,89%</td>-->
            <td align="center">6,89%</td>

            <td align="center">6,85%</td>
            <td align="center">6,95%</td>

          </tr>

          <tr>
            <td>{{ 'competitivness'|translate }}</td>
            <td>Market Share Lançamentos (IQVIA ult 24m) BR</td>

            <!--<td align="center">6,43%</td>
            <td align="center">6,85%</td>
            <td align="center">6,21%</td>
            <td align="center">6,78%</td>
            <td align="center">6,58%</td>-->

            <td align="center">8,30%</td>
            <td align="center">7,25%</td>
            <!--<td align="center">6,35%</td>
            <td align="center">6,51%</td>-->
            <td align="center">6,51%</td>

            <td align="center">6,97%</td>
            <td align="center">7,79%</td>
          </tr>

          <tr>
            <td>{{ 'innovationatpd'|translate }}</td>
            <td>{{ 'incrementalprojects'|translate }}</td>

            <!--<td align="center">-</td>
            <td align="center">-</td>
            <td align="center">-</td>
            <td align="center">-</td>
            <td align="center">-</td>-->

            <td align="center">-</td>
            <td align="center">-</td>
            <!--<td align="center">-</td>
            <td align="center">-</td>-->
            <td align="center">-</td>

            <td align="center">-</td>
            <td align="center">34%</td>
          </tr>

          <tr>
            <td>{{ 'openinovation'|translate }}</td>
            <td>{{ 'numberofatacks'|translate }}</td>

            <!--<td align="center">10</td>
            <td align="center">10</td>
            <td align="center">10</td>
            <td align="center">10</td>
            <td align="center">10</td>-->

            <td align="center">10</td>
            <td align="center">11</td>
            <!--<td align="center">11</td>
            <td align="center">11</td>-->
            <td align="center">43</td>

            <td align="center">11</td>
            <td align="center">11</td>
          </tr>

          <tr>
            <td>Compliance - Treinamento</td>
            <td>{{ 'quantityActionCompliance'| translate }}</td>

            <!--<td align="center">-</td>
            <td align="center">10</td>
            <td align="center">6</td>
            <td align="center">3</td>
            <td align="center">13</td-->

            <td align="center">0</td>
            <td align="center">3</td>
            <!--<td align="center">19</td>
            <td align="center">25</td>-->
            <td align="center">47</td>

            <td align="center">36</td>
            <td align="center">2</td>
          </tr>

          <tr>
            <td>Compliance - Treinamento</td>
            <td>{{ 'sectionTrainingCompliance'| translate }}</td>

            <!--<td align="center">-</td>
            <td align="center">13</td>
            <td align="center">15</td>
            <td align="center">1</td>
            <td align="center">29</td-->

            <td align="center">11</td>
            <td align="center">15</td>
            <!--<td align="center">24</td>
            <td align="center">33</td>-->
            <td align="center">83</td>

            <td align="center">21</td>
            <td align="center">35</td>
          </tr>

          <tr>
            <td>Compliance - Treinamento</td>
            <td>{{ 'sectionTrainingCompliancePartners'| translate }}</td>

            <!--<td align="center">-</td>
            <td align="center">1</td>
            <td align="center">0</td>
            <td align="center">1</td>
            <td align="center">2</td>-->

            <td align="center">3</td>
            <td align="center">119</td>
            <!--<td align="center">51</td>
            <td align="center">65</td>-->
            <td align="center">238</td>

            <td align="center">110</td>
            <td align="center">64</td>
          </tr>

          </tbody>
        </table>
      </div>
    </div>

  </div>
</div>


<ng-container *ngIf="false">
  <section class="banners">
    <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="primarySlider">
      <ng-container *ngFor="let b of banners">
        <div ngxSlickItem class="slide" *ngIf="b.type === 'banner'"
             [style]="{'background-size': 'cover', 'background-image': 'url('+ b.bannerUrl +')'}">
          <div class="container">
            <h2 class="banners__title" [innerHtml]="b.title"></h2>
            <p class="banners__description" [innerHtml]="b.description"></p>
            <img src="/assets/images/seal.png" alt="" width="100%">
          </div>
        </div>
      </ng-container>
    </ngx-slick-carousel>
    <svg-icon class="banners__down svg" src="assets/images/scroll.svg"></svg-icon>
  </section>

  <section class="shortcut">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-6 shortcut__head">
          <h2 class="shortcut__title" [innerHTML]="'indicatorscentral'|translate"></h2>
        </div>
        <div class="col-12 col-md-6">
          <p [innerHTML]="'indicatorscentralpresents'|translate"></p>
          <p [innerHTML]="'usethesuperiormenu'|translate"></p>
        </div>
      </div>
    </div>
  </section>

  <ng-container *ngFor="let b of banners">
    <section class="sustentability" *ngIf="b.type === 'background'"
             [style]="{'background-size': 'cover', 'background-image': 'url('+ b.bannerUrl +')'}">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-5">
            <h2 class="sustentability__title">{{ 'sustainableprimer'|translate }}</h2>
            <p class="page__text"> {{ 'checkthemainactions'|translate }}</p>
            <a href="#" class="page__btn btn btn-outline-primary">
              <span>{{ 'downloadhere'|translate }}</span>
              <svg-icon class="svg" src="assets/images/right.svg"></svg-icon>
            </a>
          </div>
        </div>
      </div>
    </section>
  </ng-container>

  <ng-container>
    <div *ngFor="let b of highlights; let i = index;">
      <div class="central__slide"> <!--cat-3-->
        <h3 *ngIf="!isNullOrUndefined(b.itens)" class="central__title">
          <img [src]="b.icon" alt=""/>
          <span [style]="{'color': b.color}">{{ b.name }}</span>
        </h3>


        <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="thirdSlider">
          <div *ngFor="let x of b.itens" ngxSlickItem>
            <div class="slide" class="central__item" [style]="{'background-color': b.color}">
              <h4 class="central__item__title">
                <span>{{ x.title }}</span>
                <!--<small> {{x.title}}</small>-->
              </h4>
              <p class="central__item__text">{{ x.description }}</p>
            </div>
          </div>
        </ngx-slick-carousel>


      </div>
    </div>
  </ng-container>

  <section class="central page js-counter-up d-none">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-8">
          <h2 class="page__title" [innerHTML]="'indicatorscentral'|translate"></h2>
          <p class="page__text" [innerHTML]="'theindicatorscentralpresents'|translate"></p>
          <br>
          <p class="page__text" [innerHTML]="'usethesuperiormenu'|translate"></p>
        </div>
      </div>
    </div>

  </section>
</ng-container>
